module.exports = __webpack_public_path__ + "assets/left-arrow@2x.png?69e25f5114afd6a093328dc060518499";